import { GAME_ID, REDUX_ACTIONS } from '../../data/constants';

import { getItemsCount } from '../../content/curriculum';

const initialState = {
  hasSeenOnboarding: false,
  hasSeenPronounLevels: false,
  level: 0,
  progress: 0,
  correctItemsCount: 0, // TODO: cleanup: can probably be derived from a selector standard + sentence count
  correctStandardItemsCount: 0,
  correctSentenceItemsCount: 0,
  disabledWordsId: { verbs: [], pronouns: [] },
  lastSelectedWords: {},
  standardItemsCount: 0, // TODO: cleanup: not necesary on reducer, can be read by curriculum selectors
  sentenceItemsCount: 0, // TODO: cleanup: not necesary on reducer, can be read by curriculum selectors
  completedWords: [],
};

const roundReducer = (state = initialState, { gameId, type, payload }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.START_LEVEL: {
      const { level } = payload;

      const { standardItemsCount, sentenceItemsCount } = getItemsCount(level);
      const { hasSeenOnboarding, hasSeenPronounLevels } = state;
      return {
        ...initialState,
        standardItemsCount,
        sentenceItemsCount,
        hasSeenOnboarding,
        hasSeenPronounLevels,
        level,
      };
    }

    case REDUX_ACTIONS.ADD_DISABLED_WORDS_ID: {
      const { verbs, pronouns } = state.disabledWordsId;
      const { verb, pronoun } = payload;

      return {
        ...state,
        disabledWordsId: {
          verbs: verb ? [...verbs, verb] : verbs,
          pronouns: pronoun ? [...pronouns, pronoun] : pronouns,
        },
      };
    }

    case REDUX_ACTIONS.CLEAR_DISABLED_WORDS_ID: {
      const { verbs, pronouns } = state.disabledWordsId;
      const { pronoun = true, verb = true } = payload;

      return {
        ...state,
        disabledWordsId: {
          verbs: verb ? [] : verbs,
          pronouns: pronoun ? [] : pronouns,
        },
      };
    }

    case REDUX_ACTIONS.SET_LAST_SELECTED_WORDS: {
      return {
        ...state,
        lastSelectedWords: payload,
      };
    }

    case REDUX_ACTIONS.INCREMENT_PROGRESS: {
      const { standardItemsCount, sentenceItemsCount } = state;

      return {
        ...state,
        progress: state.progress + 100 / (standardItemsCount + sentenceItemsCount),
      };
    }

    case REDUX_ACTIONS.INCREMENT_CORRECT_ITEMS_COUNT:
      return {
        ...state,
        correctItemsCount: state.correctItemsCount + 1,
      };

    case REDUX_ACTIONS.INCREMENT_CORRECT_STANDARD_ITEMS_COUNT:
      return {
        ...state,
        correctStandardItemsCount: state.correctStandardItemsCount + 1,
      };
    case REDUX_ACTIONS.INCREMENT_CORRECT_SENTENCE_ITEMS_COUNT:
      return {
        ...state,
        correctSentenceItemsCount: state.correctSentenceItemsCount + 1,
      };

    case REDUX_ACTIONS.COMPLETE_ONBOARDING: {
      return {
        ...state,
        hasSeenOnboarding: true,
      };
    }

    case REDUX_ACTIONS.MARK_PRONOUN_LEVELS_AS_SEEN: {
      return {
        ...state,
        hasSeenPronounLevels: true,
      };
    }

    case REDUX_ACTIONS.ADD_TO_COMPLETED_WORDS: {
      return {
        ...state,
        completedWords: [...state.completedWords, payload],
      };
    }

    default:
      return state;
  }
};

export default roundReducer;
